export class ProjectCreationInitializedMessage {
  name: string;

  constructor(name: string) {
    this.name = name;
  }
}